import { publicDogModel } from "../types/publicDogModel";

const parseEuthTime = (dateStr?: string | null): number => {
	if (!dateStr) return Infinity;
	const t = new Date(dateStr).getTime();
	return Number.isNaN(t) ? Infinity : t;
};

const getUrgencyGroup = (dog: publicDogModel): number => {
	const status = dog.adoptable_status;
	const hasEuthDate = parseEuthTime(dog.euth_date) !== Infinity;
	if (status === "at_risk" && hasEuthDate) return 0; // most urgent
	if (status === "at_risk") return 1;
	if (status === "in_rescue_or_foster") return 2;
	return 3; // everything else
};

export const sortDogsByUrgency = (
	dogs: publicDogModel[],
): publicDogModel[] => {
	return [...dogs].sort((a, b) => {
		const ga = getUrgencyGroup(a);
		const gb = getUrgencyGroup(b);
		if (ga !== gb) return ga - gb;

		// Within the same group, prefer earlier euth dates if present
		const ta = parseEuthTime(a.euth_date);
		const tb = parseEuthTime(b.euth_date);
		if (ta !== tb) return ta - tb;

		// Fallback stable-ish ordering: name, then id
		const nameCmp = (a.name || "").localeCompare(b.name || "");
		if (nameCmp !== 0) return nameCmp;
		return (a.dog_id || "").localeCompare(b.dog_id || "");
	});
};

export default sortDogsByUrgency;


